import { Routes } from '@angular/router';

import { navigationGuard } from '@core/guards/navigation.guard';

export const profileSettingsRoutes: Routes = [
  {
    path: 'profile-settings',
    loadComponent: () =>
      import('@feature/profile-settings/profile-settings.component').then(
        m => m.ProfileSettingsComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profile-details',
      },
      {
        path: 'profile-details',
        loadComponent: () =>
          import('./profile-details/profile-details.component').then(
            m => m.ProfileDetailsComponent
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./notifications/notifications.component').then(
            m => m.NotificationsComponent
          ),
        canDeactivate: [navigationGuard],
      },
      {
        path: 'email-notifications',
        loadComponent: () =>
          import('./email-notification/email-notification.component').then(
            m => m.EmailNotificationComponent
          ),
        canDeactivate: [navigationGuard],
      },
    ],
  },
];
